import axios from 'axios'

const instance = axios.create()

instance.interceptors.request.use(function (request) {
  request.headers['X-Axs-Platform'] = process.env.REACT_APP_NAME
  request.headers['X-Axs-Version'] = process.env.REACT_APP_VERSION

  return request
})

export default instance
